import React from 'react';
import PropTypes from 'prop-types';
import ActiveLabel from "../../shared/components/ActiveLabel";
import LinkButton from "../../shared/components/LinkButton";
import {PsRoutes} from "../../shared/routing/Routes";
import {I18nUtils} from "../../../i18n/I18nUtils";
import RouterUtils from "../../shared/routing/RouterUtils";

export default class TypeDocumentRow extends React.Component {

    render() {
        const { typedocument } = this.props;
        const expires = {
            name: typedocument.expires ? I18nUtils.tr('TR_SI'): I18nUtils.tr('TR_NO'),
            color: typedocument.expires ? "8BC34A": "FF9800",
        };
        return (
            <tr>
                <td><strong>{typedocument.name}</strong></td>
                <td>
                    {typedocument.file_types.map((object, i) => {
                        return(<span key={i}>{object.name}{i !== typedocument.file_types.length-1 ? ", " : ""}</span>);
                    })}
                </td>
                <td><ActiveLabel state={expires} /></td>
                <td>
                    <LinkButton to={RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL, {id: typedocument.id})} text={I18nUtils.tr('TR_VER_FICHA')} className={'btn-block btn-sm'}/>
                </td>
            </tr>
        );
    }

}


TypeDocumentRow.propTypes = {
    typedocument: PropTypes.objectOf(PropTypes.any).isRequired,
};

TypeDocumentRow.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/components/TypeDocumentRow.js